import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const ITEMS = ['Corrés todo el día pero al final no sabés ni para qué.', 'Descansar te genera culpa en vez de alivio.', 'Te cuesta decir que no, aunque ya estés desbordada.', 'Un error pequeño te deja pensando en él durante horas.', 'Sos a quien todos recurren, pero nadie sostiene lo tuyo.', 'Dormís, pero te despertás igual de cansada.', 'Postergás el descanso para “cuando termine todo” y ese momento nunca llega.', 'Sentís tensión en el cuello, la mandíbula apretada o dolores de cabeza frecuentes.', 'Si bajás el ritmo, sentís que algo se va a caer o alguien se va a decepcionar.', 'Estás agotada de sostener una versión tuya que nunca te dio permiso de parar.'];
export function ForYou() {
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-48" data-mp="25dlh8bmpuv6g">
      <div className="mx-auto max-w-4xl px-6" data-id="element-49" data-mp="21ayrcg9lvkbw">
        <SectionHeading eyebrow="¿Es para vos?" title="Este ebook es para vos si…" data-id="element-50" data-mp="21c9y8oycl878" />
        <ul className="mt-14 grid grid-cols-1 gap-x-10 gap-y-5 md:grid-cols-2" data-id="element-51" data-mp="396setgyykest">
          {ITEMS.map((item, i) => <motion.li key={i} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          ease: 'easeOut',
          delay: i % 2 * 0.06
        }} className="flex items-start gap-4 border-b border-ink/10 pb-5" data-id="element-52" data-mp="3e5v8645kswky" data-mpi={i}>
              <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-sage/15 text-sage" data-id="element-53" data-mp="22iv7i53bo13d">
                <CheckIcon size={14} strokeWidth={2.5} data-id="element-54" data-mp="27gwsivkb6ahh" />
              </span>
              <span className="font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-55" data-mp="1zgqp3zdwm0y1">
                {item}
              </span>
            </motion.li>)}
        </ul>
        <p className="mt-12 text-center font-serif text-2xl italic text-ink" data-id="element-56" data-mp="1vhro2pvamobv">
          Si te reconocés en al menos tres, esta guía es para vos.
        </p>
      </div>
    </section>;
}